import Style from "@client/controls/HTML/Style/component";
import { STYLE_SHEET_IDS } from "@client/lib/styleSheet";
import { UPGRADE_STYLE_SHEET_IDS } from "@client/lib/upgrade/050000";
import { type GenericMap } from "@client/types";
import { type StyleSheetTextType } from "@client/types/StyleSheet";
import React from "react";
import { getStyleSheetColorClassName } from "../lib";

export const TEXT_TAGS: StyleSheetTextType[] = ["text", "h1", "h2", "h3", "h4", "h5", "h6"];

type Props = {
  id: string;
  setting: GenericMap<any>;
};
export default (props: Props) => {
  const css = React.useMemo(() => {
    return TEXT_TAGS.map((x) => {
      let css = [
        `.${getStyleSheetColorClassName(x, props.id)} ${x === "text" ? "" : x} {
        color: ${props.setting.color};
      }`
      ];

      if (props.id === STYLE_SHEET_IDS.defaults.textColor) {
        css.push(`body ${x === "text" ? "" : x} {
          color: ${props.setting.color};
        }`);
      }

      return css.reverse().join("\n");
    }).join("\n");
  }, [props.setting.color, props.id]);

  const finalCss = React.useMemo(() => {
    // 500 upgrade adds h1-6 colors. Use this workaround to set correct colors
    const upgradeEntry = Object.entries(UPGRADE_STYLE_SHEET_IDS.colors).find((x) => props.id === x[1]);
    if (upgradeEntry && upgradeEntry[0].startsWith("h")) {
      return `${css}\nbody ${upgradeEntry[0]} {
        color: ${props.setting.color};
      }`;
    }
    return css;
  }, [css]);

  return <Style css={finalCss} />;
};
